<script lang="ts" setup>
import { AppLink } from '#components'

const { loadLayout, layoutData } = useLayout()
await loadLayout()

const getElement = (to: string | null | undefined) => {
  return to ? AppLink : 'span'
}

const year = new Date().getFullYear()
</script>

<template>
  <footer class="checkout-footer">
    <div class="checkout-footer__container">
      <CheckoutAssistance class="checkout-footer__assistance" />

      <AppPaymentIcons class="checkout-footer__payment-icons" />

      <AppDeliveryIcons class="checkout-footer__delivery-icons" />

      <div class="checkout-footer__copyright">
        &copy; Copyright {{ year }} {{ $t('meta.name') }}
      </div>

      <div
        v-if="layoutData?.legal?.[0]"
        class="checkout-footer__legal"
      >
        <strong class="footer__legal-title">
          {{ layoutData?.legal[0].Title }}
        </strong>
        <ul class="footer__legal-list">
          <li
            v-for="(group, index) in layoutData?.legal[0]?.Links"
            :key="index"
          >
            <component
              :is="getElement(group.Link)"
              v-if="group.Name"
              :to="group.Link"
            >
              {{ group.Name }}
            </component>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<style>
@import url("~layers/app/components/Checkout/Footer.css");
</style>
